import type { PiralPlugin } from 'piral-core'
import { trackEvent, trackError, trackMeasurement } from './faro'
import type { PiletTelemetryApi } from './types'

export type { PiletTelemetryApi, TelemetryAttributes, TelemetryValues } from './types'

/**
 * Piral plugin that puts `trackEvent`, `trackMeasurement` and `trackError` on every
 * pilet's API.
 *
 * The shell owns the Faro instance for the same reason it owns the domain
 * configuration and the i18next instance: there must be exactly one. A pilet that
 * bundled `@grafana/faro-web-sdk` itself would get a second instance with its own
 * session, its own transport and its own view state — the `use-persisted-state`
 * failure mode, but for observability, and invisible until you notice the dashboards
 * disagree with themselves.
 *
 * Handing out plain functions (rather than the Faro object) is what keeps that
 * ownership real: a pilet cannot reconfigure the instance, change the collector, or
 * bypass the consent gate the functions enforce.
 */
export function createTelemetryApi (): PiralPlugin<PiletTelemetryApi> {
  return () => ({
    trackEvent,
    trackMeasurement,
    trackError,
  })
}
